import React, { useEffect, useState, useCallback } from "react";
import Table from "@components/table";
import { NotificationApi } from "@apis/index";
import styled from "@emotion/styled";

const StatusBadge = styled.div<{ isRead: boolean }>`
  display: inline-flex;
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 700;
  background: ${(props) => (props.isRead ? "#f3f4f6" : "#ecfdf5")};
  color: ${(props) => (props.isRead ? "#6b7280" : "#10b981")};
`;

const Notifications = ({ state }: { state: any }) => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await NotificationApi.list({
        params: {
          limit: 10,
          page: page,
          userId: state.id,
          role: "delivery",
        },
      });
      setData(res.items || []);
      setTotalPages(res.totalPages || 1);
      setTotalItems(res.totalItems || 0);
    } catch (error) {
      console.error("Failed to fetch notifications", error);
    } finally {
      setLoading(false);
    }
  }, [page, state.id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      title: "Title",
      key: "title",
      width: "25%",
      render: (row: any) => (
        <span style={{ fontWeight: row.isRead ? 400 : 700 }}>{row.title}</span>
      ),
    },
    {
      title: "Message",
      key: "message",
      width: "45%",
      render: (row: any) => <span>{row.message}</span>,
    },
    {
      title: "Status",
      key: "isRead",
      width: "10%",
      render: (row: any) => (
        <StatusBadge isRead={row.isRead}>
          {row.isRead ? "Read" : "Unread"}
        </StatusBadge>
      ),
    },
    {
      title: "Date",
      key: "createdAt",
      width: "20%",
      render: (row: any) => (
        <span>{new Date(row.createdAt).toLocaleString()}</span>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px 0" }}>
      <Table
        columns={columns}
        data={data}
        loading={loading}
        totalItems={totalItems}
        totalPages={totalPages}
        pageControlled={page}
        onPageChange={setPage}
      />
    </div>
  );
};

export default Notifications;
